import { Navigate } from "react-router-dom";

import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { loading, user } = useAuth();

  if (loading) {
    return (
      <main className="app-loader" data-testid="session-loading-state">
        <span className="loader-mark" />
        Verificando acceso
      </main>
    );
  }

  return user ? children : <Navigate to="/login" replace />;
}
